// extracted by mini-css-extract-plugin
export var alertIcon = "_pt-0";